import { useAuthProtection } from '@hooks/useAuthProtection';
import { ProductForm } from './ProductForm';

import { MainLayout } from '@layouts/MainLayout';
import { HalalShopPageSection } from '@pages/HalalShopPage/types';
import { FC, memo } from 'react';
import { useParams } from 'react-router-dom';

const _HalalShopProductDetailPage: FC = () => {
  useAuthProtection();
  const params = useParams();

  const [idPart, pagePart] = params.id?.split('&backLink=') || [null, '1'];
  const id = Number(idPart);
  const pageIndex = pagePart || '1';

  return (
    <MainLayout.Content>
      <MainLayout.Content.BackLink
        to={`/halalShop?section=${HalalShopPageSection.Catalog}&page=${pageIndex}`}>
        Все товары
      </MainLayout.Content.BackLink>
      <ProductForm productId={id} />
    </MainLayout.Content>
  );
};

export const HalalShopProductDetailPage = memo(_HalalShopProductDetailPage);
